import _ from "lodash";
import moment from "moment";

const removeWhiteSpace = text => text.replace(/\s/g, "");

export const DEFAULT_ERROR_MESSAGE = "Default Server Error";

const getErrorResponseMessage = (response, defaultMessage) => {
	let errorMessage = defaultMessage || DEFAULT_ERROR_MESSAGE;

	const message = _.get(response, "0.message");
	if (message) {
		errorMessage = message;
	}

	return errorMessage;
};

const getDataResponse = response => {
	if (response.data && response.data.error_code !== 0) {
		throw response.data;
	} else {
		return response.data.data;
	}
};

export default {
	getErrorResponseMessage,
	getDataResponse,
	notifyError: ({ context, error, options }) => {
		const title = context.$t(`Notify.${removeWhiteSpace("Error Title")}`);
		const message = error ? error.message || error.errors : context.$t(`Notify.${removeWhiteSpace(DEFAULT_ERROR_MESSAGE)}`);

		return context.$vs.notify({
			title: title,
			text: message,
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "danger",
			time: 30000,
			...options
		});
	},

	notifySuccess: ({ context, options }) => {
		return context.$vs.notify({
			title: context.$t(`Notify.Notification`),
			text: context.$t(removeWhiteSpace(`Notify.Handle Successful`)),
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "success",
			time: 5000,
			...options
		});
	},

	notifyWarning: ({ context, options }) => {
		return context.$vs.notify({
			title: context.$t(`Notify.Notification`),
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "warning",
			time: 5000,
			...options
		});
	},
	numFormat(num, dec, isHasCurrency) {
		if (typeof num === "undefined") return "";
		// let preferences = user.getUserRefs();
		let decimals = dec || 0;
		let lang = "en";
		let decimalPoint = lang === "vi" ? "," : ".";
		let separator = lang === "vi" ? "." : ",";
		const currency = lang === "vi" ? "VNĐ" : "";
		if (isHasCurrency) {
			return number_format(Number(num), decimals, decimalPoint, separator) + ` ${currency}`;
		}
		return number_format(Number(num), decimals, decimalPoint, separator);
	},
	momentFormat(datetime = undefined, format = "DD/MM/YYYY") {
		return moment(datetime).format(format);
	},
	momentFormatLocale(datetime = undefined, format = "DD/MM/YYYY", extra = 7) {
		return moment(datetime)
			.add(extra, "hours")
			.format(format);
	},
	buildUrl(url, parameters) {
		let qs = "";
		console.log(parameters);
		for (const key in parameters) {
			if (parameters.hasOwnProperty(key)) {
				const value = parameters[key];
				console.log(parameters);
				qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
			}
		}
		if (qs.length) {
			qs = qs.substring(0, qs.length - 1); //chop off last "&"
			url = url + "?" + qs;
		}
		return url;
	},
	removeVietnameseAccent(str) {
		return str
			? str
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "")
					.replace(/đ/g, "d")
					.replace(/Đ/g, "D")
			: "";
	},
	averageGeolocation(coords) {
		if (coords.length === 1) {
			return coords[0];
		}

		let x = 0.0;
		let y = 0.0;
		let z = 0.0;

		for (let coord of coords) {
			let latitude = (coord.latitude * Math.PI) / 180;
			let longitude = (coord.longitude * Math.PI) / 180;

			x += Math.cos(latitude) * Math.cos(longitude);
			y += Math.cos(latitude) * Math.sin(longitude);
			z += Math.sin(latitude);
		}

		let total = coords.length;

		x = x / total;
		y = y / total;
		z = z / total;

		let centralLongitude = Math.atan2(y, x);
		let centralSquareRoot = Math.sqrt(x * x + y * y);
		let centralLatitude = Math.atan2(z, centralSquareRoot);

		return {
			latitude: (centralLatitude * 180) / Math.PI,
			longitude: (centralLongitude * 180) / Math.PI
		};
	},
	baseLocalSort(data, key = "name") {
		var collator = new Intl.Collator(undefined, {
			numeric: true,
			sensitivity: "base"
		});
		return data.sort((a, b) => {
			return collator.compare(a[key], b[key]);
		});
	},
	zeroPad(num, places) {
		var zero = places - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;
	},
	getWorkShifts(arr = false) {
		let shifts = {
			"1": "Ca 1",
			"2": "Ca 2",
			"3": "Ca 3",
			hc: "Hành chánh",
			bx: "Bốc xếp",
			sale: "Sales",
			ktvn: "Kỹ thuật vùng nuôi",

			fillet: "Tổ Fillet",
			suaca: "Tổ Sửa cá",
			xepkhuon1: "Tổ Xếp khuôn 1",
			xepkhuon2: "Tổ Xếp khuôn 2",
			thanhpham1: "Tổ Thành phẩm 1",
			thanhpham2: "Tổ Thành phẩm 2",
			kholanh: "Tổ Kho lạnh",
			surimi: "Tổ Surimi"
		};
		if (!arr) {
			return shifts;
		}
		let workShifts = [];
		for (let k in shifts) {
			workShifts.push({
				value: k,
				name: shifts[k]
			});
		}
		return workShifts;
	},
	locateWorkShift(key) {
		let shifts = this.getWorkShifts();
		return shifts.hasOwnProperty(key) ? shifts[key] : "-";
	},
	setLocal(k, v) {
		if (typeof localStorage === "object" && localStorage) {
			localStorage.setItem(k, v);
		}
	},
	getLocal(k) {
		if (typeof localStorage === "object" && localStorage) {
			return localStorage.getItem(k);
		}
		return null;
	}
};

export function number_format(number, decimals, decPoint, thousandsSep) {
	// eslint-disable-line camelcase
	//  discuss at: http://locutus.io/php/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// improved by: davook
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// bugfixed by: Michael White (http://getsprink.com)
	// bugfixed by: Benjamin Lupton
	// bugfixed by: Allan Jensen (http://www.winternet.no)
	// bugfixed by: Howard Yeend
	// bugfixed by: Diogo Resende
	// bugfixed by: Rival
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	//  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	//  revised by: Luke Smith (http://lucassmith.name)
	//    input by: Kheang Hok Chin (http://www.distantia.ca/)
	//    input by: Jay Klehr
	//    input by: Amir Habibi (http://www.residence-mixte.com/)
	//    input by: Amirouche
	//   example 1: number_format(1234.56)
	//   returns 1: '1,235'
	//   example 2: number_format(1234.56, 2, ',', ' ')
	//   returns 2: '1 234,56'
	//   example 3: number_format(1234.5678, 2, '.', '')
	//   returns 3: '1234.57'
	//   example 4: number_format(67, 2, ',', '.')
	//   returns 4: '67,00'
	//   example 5: number_format(1000)
	//   returns 5: '1,000'
	//   example 6: number_format(67.311, 2)
	//   returns 6: '67.31'
	//   example 7: number_format(1000.55, 1)
	//   returns 7: '1,000.6'
	//   example 8: number_format(67000, 5, ',', '.')
	//   returns 8: '67.000,00000'
	//   example 9: number_format(0.9, 0)
	//   returns 9: '1'
	//  example 10: number_format('1.20', 2)
	//  returns 10: '1.20'
	//  example 11: number_format('1.20', 4)
	//  returns 11: '1.2000'
	//  example 12: number_format('1.2000', 3)
	//  returns 12: '1.200'
	//  example 13: number_format('1 000,50', 2, '.', ' ')
	//  returns 13: '100 050.00'
	//  example 14: number_format(1e-8, 8, '.', '')
	//  returns 14: '0.00000001'

	number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
	var n = !isFinite(+number) ? 0 : +number;
	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
	var dec = typeof decPoint === "undefined" ? "." : decPoint;
	var s = "";

	var toFixedFix = function(n, prec) {
		if (("" + n).indexOf("e") === -1) {
			return +(Math.round(n + "e+" + prec) + "e-" + prec);
		} else {
			var arr = ("" + n).split("e");
			var sig = "";
			if (+arr[1] + prec > 0) {
				sig = "+";
			}
			return (+(Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) + "e-" + prec)).toFixed(prec);
		}
	};

	// @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || "").length < prec) {
		s[1] = s[1] || "";
		s[1] += new Array(prec - s[1].length + 1).join("0");
	}

	return s.join(dec);
}
